import { lt } from '@mews/framework';
import { Icon, IconName, Stack } from '@optimus-web/core';
import { ReservationContractSignatureStatus } from '@mews-commander/data-access';

export const SignatureStatusLabel = ({ status }: { status: ReservationContractSignatureStatus }) => (
    <Stack spacing="100" itemAlignment="center">
        {status === ReservationContractSignatureStatus.Signed && (
            <>
                <Icon value={IconName.Done} />
                {lt('ContractSignatureStatusSignedLabel')}
            </>
        )}
        {status === ReservationContractSignatureStatus.Pending && (
            <>
                <Icon value={IconName.Hourglass} />
                {lt('ContractSignatureStatusPendingLabel')}
            </>
        )}
        {status === ReservationContractSignatureStatus.NotSigned && (
            <>
                <Icon value={IconName.Disable} />
                {lt('ContractSignatureStatusNotSignedLabel')}
            </>
        )}
    </Stack>
);
